<template>
    <v-card tile>
        <v-container
        class="py-0"
        fluid>
            <v-row
                align="center"
                justify="center"
                class="dashboard-links"
            >
                <v-col
                    cols="6"
                    sm="6"
                    md="6"
                    lg="6"
                >
                    <v-card
                        color="primary"
                        dark
                        to="/jobs"
                        flat
                        tile
                    >
                        <v-card-title class="headline d-flex justify-center">                             
                            <v-icon
                                large
                                left
                            >
                                mdi-map-marker-down
                            </v-icon>
                            <span class="subtitle-1 font-weight-light">Schedule</span>
                        </v-card-title>
                    </v-card>
                </v-col>
                <v-col
                    cols="6"
                    sm="6"
                    md="6"
                    lg="6"
                >
                    <v-card
                        color="primary"
                        dark
                        to="/customers"
                        flat
                        tile
                    >
                        <v-card-title class="headline d-flex justify-center">                             
                            <v-icon
                                large
                                left
                            >
                                mdi-account-group
                            </v-icon>
                            <span class="subtitle-1 font-weight-light">Customers</span>
                        </v-card-title>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        >
            <v-tab>Complete a Job</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat tile class="primary">
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="jobFields">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Customer" rules="required">
                                                <v-autocomplete
                                                    v-model="form.customer"
                                                    :items="customers"
                                                    :loading="isLoading"
                                                    :search-input.sync="search"
                                                    hide-no-data
                                                    hide-selected
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Customer"
                                                    placeholder="Start typing to Search"
                                                    prepend-icon="mdi-database-search"
                                                    return-object
                                                    required
                                                    :error-messages="errors"
                                                ></v-autocomplete>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="admin-action">
                        <v-spacer></v-spacer>
                        <v-btn large text :to="{ name: 'New Customer', params: { redirect: 'Dashboard' }}">Add New Customer</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions> 
                </v-card>
                <v-card flat>
                    <v-card-text>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                                v-for="(chemical, index) in form.chemicals" :key="`repeater-${index}`"
                            >
                                <div class="repeater">
                                    <v-select
                                        v-model="chemical.product"
                                        :items="chemicals"
                                        item-text="label"
                                        item-value="value"
                                        label="Product"
                                    ></v-select>
                                    <v-text-field v-model="chemical.qty" type="number" label="Quantity" append-outer-icon="add" @click:append-outer="increment(index)" prepend-icon="remove" @click:prepend="decrement(index)"></v-text-field>
                                    <v-select
                                        v-model="chemical.measurement_type"
                                        :items="measurement_types"
                                        label="Measurement Type"
                                    ></v-select>
                                    <v-btn class="mx-2" color="secondary" fab x-small dark @click="remove(index)" v-show="index || ( !index && form.chemicals.length > 1)">
                                        <v-icon dark>mdi-minus</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="row-action">
                        <v-spacer></v-spacer>
                        <v-btn large text @click="add">Add New Row</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions> 
                    <v-card-text class="secondary">
                        <v-textarea
                            v-model="form.comment"
                            label="Job Comments"
                            filled
                            hide-details
                            dark
                            color="white"
                        ></v-textarea>
                        <v-textarea
                            v-model="form.customer_comment"
                            label="Customer Comments"
                            filled
                            hide-details
                            dark
                            color="white"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn large min-width="50%" color="blue darken-1" text @click="clear">Clear</v-btn>                        
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading">Complete the Job</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import axios from 'axios'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        data: () => ({
            tab: null,
            form: {
                customer: {
                    label: '',
                    value: ''
                },
                chemicals: [
                    {
                        product: '',
                        measurement_type: '',
                        qty: 1
                    },
                    {
                        product: '',
                        measurement_type: '',
                        qty: 1
                    },
                    {
                        product: '',
                        measurement_type: '',
                        qty: 1
                    },
                    {
                        product: '',
                        measurement_type: '',
                        qty: 1
                    }
                ],                
            },
            customer_comment: '',
            comment: '',
            loading: false,
            isLoading: false,
            search: null,
            customers: [],
        }),
        mounted() {
            this.getData()

            if(this.$route.params.customer) {
                this.form.customer.label = this.$route.params.customer.title
                this.form.customer.value = this.$route.params.customer.id

                this.customers.push({...this.form.customer})
            }
        },
        watch: {
            search (val) {
                // Items have already been requested
                if (this.isLoading) return

                this.isLoading = true

                axios.get('cleaners/customers/search', {
                    params: {
                        keyword: val
                    }
                })
                .then(response => {
                    this.customers = response.data.customers
                    this.$nextTick()
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.isLoading = false))
            },
        },
        computed: {
            ...mapGetters({
                statuses: 'data/statusArray',
                cleaners: 'data/cleaners',
                chemicals: 'data/chemicals',
                measurement_types: 'data/measurement_types'
            }),
            filteredStatuses() {
                return this.statuses.filter(status => {
                    return status.value != 'all'
                })
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver
        },
        methods: {
            ...mapActions({
                getData: 'data/getData',
                completeJob: 'data/completeJob',
            }),
            async submit() {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    this.completeJob(this.form).then(() => {
                        this.loading = false
                        this.clear() 
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                    }).catch(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                    if(!valid1) {
                        this.tab = 0
                    }
                }
            },
            add() {
                this.form.chemicals.push({                         
                    product: '',
                    measurement_type: '',
                    qty: 1
                });
            },
            remove(index) {
                this.form.chemicals.splice(index, 1);
            },
            increment (index) {
                this.form.chemicals[index].qty = parseInt(this.form.chemicals[index].qty,10) + 1
            },
            decrement (index) {
                this.form.chemicals[index].qty = parseInt(this.form.chemicals[index].qty,10) - 1
            },
            clear() {
                this.form = {
                    customer: {
                        label: '',
                        value: ''
                    },
                    cleaner: '',
                    datetime: null,
                    status: '',
                    chemicals: [
                        {
                            product: '',
                            measurement_type: '',
                            qty: 1
                        },
                        {
                            product: '',
                            measurement_type: '',
                            qty: 1
                        },
                        {
                            product: '',
                            measurement_type: '',
                            qty: 1
                        },
                        {
                            product: '',
                            measurement_type: '',
                            qty: 1
                        }
                    ],
                    
                }
            }
        }
    }
</script>

<style lang="sass" scoped>
.admin-action 
    background: #003b70
    .v-btn
        width: 100%
        background: #ffffff
        color: #003b70
.row-action
    background: #000
    button 
        width: 100%
        background: #ffffff
        color: #000
</style>

<style lang="sass">
.dashboard-links
    padding: 4px
    background: #003b70
    
    .col-6
        padding: 4px

        .v-card 
            min-height: calc((100vh - 382px)/3)
            display: flex
            flex-wrap: wrap
            align-content: center

.repeater
    padding: 30px 20px
    background: #eee
    margin: 10px 0
    text-align: center
    border-radius: 5px
</style>
